import { formatNumber } from "@/v2-common/utils/utils.formatting"
import type { SummaryBreakdownEntry } from "./table.summary.types"
import {
  formatBreakdownShare,
  getBreakdownEntryColor,
} from "./table.summary.utils"

export type TableSummaryLegendProps = {
  entries: SummaryBreakdownEntry[]
}

/**
 * A breakdown in full, one entry per line with its count and share, for the
 * popover a summary cell opens on hover — the cell itself has room for the
 * first entry or two.
 */
function TableSummaryLegend(props: TableSummaryLegendProps) {
  const { entries } = props

  return (
    <ul className="ui-table-summary-legend">
      {entries.map((entry, index) => (
        <li key={entry.key} className="ui-table-summary-legend-entry">
          <span
            className="ui-table-summary-dot"
            style={{ backgroundColor: getBreakdownEntryColor(index) }}
            aria-hidden
          />
          <span className="ui-table-summary-legend-key">{entry.key}</span>
          <span className="ui-table-summary-legend-count">
            {formatNumber(entry.count)}
          </span>
          <span className="ui-table-summary-legend-share">
            {formatBreakdownShare(entry)}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default TableSummaryLegend
